import React, { useContext } from 'react';
import { ServerVarsContext } from '../../global/ServerVarsContext/ServerVarsContext';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';

import { ExpandableContent } from '../../components/global/ExpandableContent/ExpandableContent';

import styles from './SbRespContentModuleRegular.scss';

const MODULE_HEIGHT = 240;
const SB_TOP_NAV_VARIANT_MODULE_HEIGHT = 200;

function SbRespContentModuleRegularComponent({ browseContentModule }) {
    const { description, title, photo } = browseContentModule;
    const { isSbTopNavVariant } = useContext(ServerVarsContext);

    return (
        <div className={styles.info}>
            <ExpandableContent
                collapseHeight={
                    isSbTopNavVariant ? SB_TOP_NAV_VARIANT_MODULE_HEIGHT : MODULE_HEIGHT
                }
                buttonClassName={styles.button}
                dataTn="facet-creator-info"
                hideReadMoreArrow
            >
                {photo && (
                    <img className={styles.photo} src={photo} data-tn="facet-creator-picture" />
                )}
                <div className={styles.title} data-tn="facet-creator-title">
                    {title}
                </div>
                <span
                    className={styles.description}
                    dangerouslySetInnerHTML={{ __html: description }}
                />
            </ExpandableContent>
        </div>
    );
}

SbRespContentModuleRegularComponent.propTypes = {
    browseContentModule: PropTypes.object.isRequired,
};

export const SbRespContentModuleRegular = createFragmentContainer(
    SbRespContentModuleRegularComponent,
    {
        browseContentModule: graphql`
            fragment SbRespContentModuleRegular_browseContentModule on ContentModuleRegular {
                description
                title
                photo
            }
        `,
    }
);
